document.addEventListener("DOMContentLoaded", function() {

    const descriptionBlock = document.querySelectorAll(".js-description");

    if (descriptionBlock.length > 0) {

        descriptionBlock.forEach(function(el) {

            let height = 0;
            el.style.height = calcHeight(el, false);

            const toggleSubsectionsBtn = el.querySelectorAll(".js-toggle-description");

            if(toggleSubsectionsBtn.length > 0) {

                toggleSubsectionsBtn.forEach(function(btn) {

                    btn.addEventListener("click", function() {

                        const section = this.closest(".js-description");

                        section.classList.toggle("opened");

                        if (section.classList.contains("opened")) {
                            height = calcHeight(el, true);
                            this.textContent = btn.getAttribute("hide-text"); // скрыть
                        } else {
                            height = calcHeight(el, false);
                            this.textContent = btn.getAttribute("show-text"); // подробнее
                        }

                        el.style.height = height;
                    });
                });
            }

            setTimeout(function() {
                el.classList.add("transition");
            },0);

        });
    }

    window.addEventListener("resize", function(){

        descriptionBlock.forEach(function(el) {
            el.style.height = calcHeight(el, false);
        });
    });

});

function calcHeight(blockDescription, isOpened) {
    let height = 0,
        padding = 0,
        fullHeight = 0,
        btnHeight = 0,
        imgHeight = 0;

    imgHeight = $(blockDescription).find(".img-wrap").outerHeight(true);
    btnHeight = $(blockDescription).find(".js-toggle-description").outerHeight(true);

    if (window.innerWidth < 768) {
        padding = 24 + btnHeight;
    } else {
        padding = 60;
    }

    if (!isOpened) {
        fullHeight = $(blockDescription).find(".short").outerHeight(true);
    } else {

        fullHeight = $(blockDescription).find(".full").outerHeight(true);

        if (window.innerWidth >= 768) {

            if (fullHeight < imgHeight) {

                fullHeight = imgHeight;

            } else {

                fullHeight += btnHeight;
            }

        } else {

            fullHeight += imgHeight;
        }
    }

    height = padding + fullHeight;

    return height + "px";
}

